/*
 *
 * CheckoutPage reducer
 *
 */

import ActionTypes from './constants';
import { ContainerState, ContainerActions } from './types';

export const initialState: ContainerState = {
  loading: false,
  orderDraftToken: '',
  checkoutStatus: {
    status: 'DRAFT',
  },
  checkout: {
    deliveryNotes: [],
    quantity: {},
    totalOfSupplier: {},
    totalBeforeVATOfSupplier: {},
    timeSlot: {},
    deliveryDate: {},
    total: 0,
  },
  vouchers: {
    data: [],
    loading: false,
    currentAppliedVoucher: null,
    status: null,
    discountedValue: -1,
  },
  somethingChanged: false,
  openConfirmSameDayDeliveryModal: false,
  invoiceNote: '',
};

function checkoutPageReducer(state: ContainerState = initialState, action: ContainerActions) {
  const { type, payload } = action as any;

  switch (type) {
    case ActionTypes.DEFAULT_ACTION:
      return state;
    case ActionTypes.CREATE_ORDER_DRAFT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ActionTypes.CREATE_ORDER_DRAFT_SUCCESS:
      return {
        ...state,
        orderDraftToken: payload.draftToken,
        loading: false,
      };
    case ActionTypes.CREATE_ORDER_DRAFT_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ActionTypes.CALCULATE_VOUCHER_REQUEST:
    case ActionTypes.GET_VOUCHER_REQUEST:
      return {
        ...state,
        vouchers: {
          ...state.vouchers,
          loading: true,
        },
      };
    case ActionTypes.GET_VOUCHER_SUCCESS:
      return {
        ...state,
        vouchers: {
          ...state.vouchers,
          ...payload,
          loading: false,
        },
      };
    case ActionTypes.CALCULATE_VOUCHER_FAILURE:
    case ActionTypes.GET_VOUCHER_FAILURE:
      return {
        ...state,
        vouchers: {
          ...state.vouchers,
          loading: false,
        },
      };
    case ActionTypes.SET_VOUCHER:
      return {
        ...state,
        vouchers: {
          ...state.vouchers,
          ...payload,
        },
      };
    case ActionTypes.SET_CHECKOUT:
      return {
        ...state,
        checkout: {
          ...state.checkout,
          ...payload,
        },
      };
    case ActionTypes.SET_CHECKOUT_TOTAL:
      return {
        ...state,
        checkout: {
          ...state.checkout,
          total: payload,
        },
      };
    case ActionTypes.SET_CHECKOUT_STATUS:
      return {
        ...state,
        checkoutStatus: {
          ...payload,
        },
      };
    case ActionTypes.CHECKOUT_CART_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ActionTypes.CHECKOUT_CART_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ActionTypes.CHECKOUT_CART_SUCCESS:
      return {
        ...state,
        checkoutStatus: payload,
        loading: false,
      };
    case ActionTypes.SET_OPEN_CONFIRM_SAME_DAY_DELIVERY_MODAL:
      return {
        ...state,
        openConfirmSameDayDeliveryModal: payload,
      };
    case ActionTypes.SOMETHING_CHANGED:
      return {
        ...state,
        somethingChanged: !state.somethingChanged,
      };
    case ActionTypes.CHANGE_INVOICE_NOTE:
      return {
        ...state,
        invoiceNote: payload,
      };
    default:
      return state;
  }
}

export default checkoutPageReducer;
